var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75065 1.9935C5.07065 1.9935 2.08398 4.98017 2.08398 8.66017C2.08398 12.3402 5.07065 15.3268 8.75065 15.3268C12.4307 15.3268 15.4173 12.3402 15.4173 8.66017C15.4173 4.98017 12.4307 1.9935 8.75065 1.9935ZM8.08398 13.9468C5.45065 13.6202 3.41732 11.3802 3.41732 8.66017C3.41732 8.24683 3.47065 7.8535 3.55732 7.46683L6.75065 10.6602V11.3268C6.75065 12.0602 7.35065 12.6602 8.08398 12.6602V13.9468ZM12.684 12.2535C12.5107 11.7135 12.0173 11.3268 11.4173 11.3268H10.7507V9.32683C10.7507 8.96017 10.4507 8.66017 10.084 8.66017H6.08398V7.32683H7.41732C7.78398 7.32683 8.08398 7.02683 8.08398 6.66017V5.32683H9.41732C10.1507 5.32683 10.7507 4.72683 10.7507 3.9935V3.72017C12.704 4.5135 14.084 6.42683 14.084 8.66017C14.084 10.0468 13.5507 11.3068 12.684 12.2535Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIcon);
export default __webpack_public_path__ + "static/media/siteIcon.329f3f4e8294eebb5f0758304bbe760b.svg";
export { ForwardRef as ReactComponent };